import { Link } from "react-router-dom";

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  action,
  actionTo,
}: {
  eyebrow: string;
  title: string;
  desc?: string;
  action?: string;
  actionTo?: string;
}) {
  return (
    <div className="mb-7 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
          <span className="inline-block h-px w-6 bg-primary-500" aria-hidden="true" />
          {eyebrow}
        </p>
        <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-6 text-foreground-600">{desc}</p>}
      </div>
      {action && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition hover:border-primary-400 hover:text-primary-700"
        >
          {action}
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}